// tslint:disable-next-line:no-import-side-effect
import 'react-app-polyfill/ie11';
// tslint:disable-next-line:no-import-side-effect
import 'react-app-polyfill/stable';
// tslint:disable-next-line:no-import-side-effect
import 'core-js/features/number/is-nan';
// tslint:disable-next-line:no-import-side-effect
import 'core-js/features/array/includes';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { App, Infrastructure, Metrics } from 'shared';
import { Provider } from 'react-redux';
import { router } from './app';
// tslint:disable-next-line:no-import-side-effect
import './sass/main.scss';
import { I18nInitializer } from 'utils/I18nInitializer';
import { fixFullHeightInMobileBrowsers } from './infrastructure/app-helper';
import * as Sentry from '@sentry/browser';
import { BUILD_VERSION, STAGE_NAME } from 'shared/app/constants';
import { setupAxios } from 'infrastructure/axios-interceptors/setup-axios';
import { IAppState } from 'shared/app/store';

const runApp = () => {
  App.Constants.initialize();

  if (App.Constants.AnalyticsSettings().Sentry.IsEnabled) {
    Sentry.init({
      dsn: App.Constants.AnalyticsSettings().Sentry.DSN,
      environment: STAGE_NAME,
      release: BUILD_VERSION,
    });
    App.ErrorHandling.setErrorReporter(error => {
      Sentry.captureException(error);
    });
    App.ErrorHandling.setMessageReporter(message => {
      Sentry.captureMessage(message);
    });
  }
  const defaultState: IAppState = {
    app: 'Patient App',
    error: { error: null },
  };

  const store = App.configureAppStore(true, [], defaultState);
  const { dispatch } = store;

  Infrastructure.setupDefaultLogger();
  Infrastructure.setupDispatch(dispatch);
  // Turned off annoying hearbeat. Sry creator of this. :)
  // Infrastructure.startPeriodicBeat(dispatch, App.Constants.heartBeatPeriod);

  setupAxios(store);

  fixFullHeightInMobileBrowsers();

  const AppContainer = (
    <Provider store={store}>
      <App.ErrorHandling.ErrorBoundary>
        <React.Suspense>
          <I18nInitializer>
            <RouterProvider router={router} />
          </I18nInitializer>
        </React.Suspense>
      </App.ErrorHandling.ErrorBoundary>
    </Provider>
  );

  const rootElement = document.getElementById('root') as HTMLElement;
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppContainer);
};

const main = () => {
  const { executionTimeInMs } = Metrics.measureTime(() => runApp());
  Infrastructure.logger().info(`Application is up and running in ${executionTimeInMs} ms`);
};
main();
